import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Link } from '@repo/ui/Link';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
import Image from 'next/image';
const transUnionLinkClass = css({
  mb: '3',
  '&[data-show-arrow="true"]': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  '&[data-force-mobile="true"]': {
    ml: '2'
  },
  '&[data-force-mobile="false"]': {
    ml: {
      base: '2',
      _pcMd: '0'
    },
    position: {
      _pcMd: 'relative'
    }
  }
});
export const TransUnionLink = t0 => {
  const $ = _c(12);
  const {
    forceMobile,
    hideOddsButtonArrow: t1
  } = t0;
  const hideOddsButtonArrow = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getTransunionUrl();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = !hideOddsButtonArrow;
  let t4;
  if ($[1] !== t3) {
    t4 = t3.toString();
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = forceMobile ?? false;
  let t6;
  if ($[3] !== t5) {
    t6 = t5.toString();
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image width={100} height={26} src="https://nerdwallet.com/cdn/cc/transunion-logo-darker-grey.svg" alt="TransUnion logo" />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== hideOddsButtonArrow) {
    t8 = !hideOddsButtonArrow && <MaskIcon glyph="arrow-forward" css={{
      boxSize: "[20px]",
      backgroundColor: "grey.400"
    }} />;
    $[6] = hideOddsButtonArrow;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t4 || $[9] !== t6 || $[10] !== t8) {
    t9 = <Link href={t2} aria-label="Get my Credit Score" underline="none" className={transUnionLinkClass} data-show-arrow={t4} data-force-mobile={t6}>{t7}{t8}</Link>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
const getTransunionUrl = () => {
  return `${process.env.NEXT_PUBLIC_NW_URL ?? ''}/home/dashboard/credit-score`;
};